import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AboutComponent } from './about.component';

@NgModule({
	declarations: [AboutComponent],
	imports: [CommonModule],
	exports: [AboutComponent]
})
export class AboutModule {}
